import OnlinePaymentTransactionModelBase from '../_generated/modelBases/online-payment-transaction-model-base';

export default class OnlinePaymentTransactionModel extends OnlinePaymentTransactionModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
